import React, { useCallback } from 'react';

import { isUserNeedKyc, needsBankAccounts, useApplicationState } from '@atlas/core';
import { Button } from '@atlas/ui';

import { goToAccountNumbersPage, goToVerificationPage } from 'src/helpers/verification';

const VerificationButton = ({ label = 'go_to_kyc', onClick }) => {
  const { account, bankAccounts } = useApplicationState();

  const processVerification = useCallback(() => {
    onClick?.();

    if (isUserNeedKyc(account)) {
      goToVerificationPage();
    } else if (needsBankAccounts(bankAccounts)) {
      goToAccountNumbersPage();
    }
  }, [account, bankAccounts, onClick]);

  return (
    <Button
      className="kyc-verification__button"
      label={label}
      onClick={processVerification}
      size="big"
      type="primary"
    />
  );
};

export default VerificationButton;
